import React from "react"

interface TransitionData {
  from: string
  to: string
  sum: number
  count: number
  avgMs: number
}

interface PeriodData {
  period: string
  transitions: TransitionData[]
  totals: {
    totalApplicationsNew: number
    totalApplicationsDoneNew: number
  }
}

interface CampaignStatsSummaryCardsProps {
  data: PeriodData[]
}

const CampaignStatsSummaryCards: React.FC<CampaignStatsSummaryCardsProps> = ({ data }) => {
  const getTotalTransitionCount = () => {
    return data.reduce(
      (total, period) =>
        total + period.transitions.reduce((sum, transition) => sum + transition.count, 0),
      0,
    )
  }

  const getTotalApplications = () => {
    return data.reduce((total, period) => total + period.totals.totalApplicationsNew, 0)
  }

  const getAverageTransitionTime = () => {
    const allTransitions = data.flatMap((period) => period.transitions)
    if (allTransitions.length === 0) {
      return 0
    }

    const totalTime = allTransitions.reduce((sum, transition) => sum + transition.avgMs, 0)
    return totalTime / allTransitions.length
  }

  const formatDuration = (durationMs: number) => {
    const durationSeconds = durationMs / 1000
    if (durationSeconds < 60) {
      return `${Math.round(durationSeconds)} saniye`
    } else if (durationSeconds < 3600) {
      return `${Math.round(durationSeconds / 60)} dakika`
    } else if (durationSeconds < 86400) {
      return `${Math.round(durationSeconds / 3600)} saat`
    } else {
      return `${Math.round(durationSeconds / 86400)} gün`
    }
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {/* Toplam Geçiş Sayısı */}
      <div className="bg-white rounded-2xl shadow-md p-6 flex flex-col justify-between h-full border border-gray-100">
        <div className="flex items-center justify-between mb-2">
          <span className="text-base font-medium text-gray-700">Toplam Geçiş Sayısı</span>
          <span className="bg-green-100 rounded-lg p-2 text-green-400 text-lg">📊</span>
        </div>
        <div className="text-3xl font-bold text-gray-900 mb-1">
          {getTotalTransitionCount().toLocaleString()}
        </div>
        <div className="text-xs text-gray-500 mt-1">Tüm geçiş işlemleri</div>
      </div>

      {/* Toplam Başvuru */}
      <div className="bg-white rounded-2xl shadow-md p-6 flex flex-col justify-between h-full border border-gray-100">
        <div className="flex items-center justify-between mb-2">
          <span className="text-base font-medium text-gray-700">Toplam Başvuru</span>
          <span className="bg-purple-100 rounded-lg p-2 text-purple-400 text-lg">📝</span>
        </div>
        <div className="text-3xl font-bold text-gray-900 mb-1">
          {getTotalApplications().toLocaleString()}
        </div>
        <div className="text-xs text-gray-500 mt-1">Yeni başvurular</div>
      </div>

      {/* Ortalama Geçiş Süresi */}
      <div className="bg-white rounded-2xl shadow-md p-6 flex flex-col justify-between h-full border border-gray-100">
        <div className="flex items-center justify-between mb-2">
          <span className="text-base font-medium text-gray-700">Ortalama Geçiş Süresi</span>
          <span className="bg-orange-100 rounded-lg p-2 text-orange-400 text-lg">⏱️</span>
        </div>
        <div className="text-2xl font-bold text-gray-900 mb-1">
          {formatDuration(getAverageTransitionTime())}
        </div>
        <div className="text-xs text-gray-500 mt-1">Tüm geçişler için ortalama</div>
      </div>
    </div>
  )
}

export default CampaignStatsSummaryCards
